export default {"src":"/_next/static/media/profileDefaultRed.fd486a57.svg","height":80,"width":80};